import { environment } from '@environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    constructor() {}

    setItem(key: string, value: any) {
        const parsedValue: string = JSON.stringify(value);
        localStorage.setItem(this.getPrefixedKey(key), parsedValue);
    }

    getItem(key: string) {
        const stringifiedObject: string = localStorage.getItem(this.getPrefixedKey(key));
        return (!!stringifiedObject && stringifiedObject !== 'undefined' ? JSON.parse(stringifiedObject) : null);
    }

    removeItem(key: string) {
        localStorage.removeItem(this.getPrefixedKey(key)); 
    }

    clear() {
        localStorage.clear();
    }

    private getPrefixedKey(key: string): string {
        return `${ environment.settings.localStoragePrefix }.${ key }`;
    }
}
